
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import {
  LayoutDashboard,
  Handshake,
  FileText,
  ScrollText,
  Phone,
  Calculator,
  Users,
  LogOut,
  CalendarDays,
  DollarSign,
  Package,
  Search,
  Building,
  Sparkles,
  MailCheck,
  Radio,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

interface AdminSidebarProps {
  onSignOut: () => void;
}

export function AdminSidebar({ onSignOut }: AdminSidebarProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Dashboard",
      icon: LayoutDashboard,
      path: "/admin-portal",
      badge: null,
    },
    {
      title: "Deals",
      icon: Handshake,
      path: "/admin-portal/deals",
      badge: null,
    },
    {
      title: "Pricing",
      icon: DollarSign,
      path: "/admin-portal/pricing",
      badge: null,
    },
    {
      title: "Quotes",
      icon: FileText,
      path: "/admin-portal/quotes",
      badge: null,
    },
    {
      title: "Agreements",
      icon: ScrollText,
      path: "/admin-portal/agreements",
      badge: null,
    },
    {
      title: "Mail Packages",
      icon: Package,
      path: "/admin-portal/mail-packages",
      badge: null,
    },
    {
      title: "County Research",
      icon: Search,
      path: "/admin-portal/county-research",
      badge: null,
    },
    {
      title: "Data Cleanup",
      icon: Sparkles,
      path: "/admin-portal/data-cleanup",
      badge: null,
    },
    {
      title: "Mailing Records",
      icon: MailCheck,
      path: "/admin-portal/mailing-records",
      badge: null,
    },
    {
      title: "Calls",
      icon: Phone,
      path: "/admin-portal/calls",
      badge: null,
    },
    {
      title: "Calculator",
      icon: Calculator,
      path: "/admin-portal/calculator",
      badge: null,
    },
    {
      title: "Amortization",
      icon: CalendarDays,
      path: "/admin-portal/amortization",
      badge: null,
    },
    {
      title: "Contacts",
      icon: Users,
      path: "/admin-portal/contacts",
      badge: null,
    },
    {
      title: "Note Seller Chatter",
      icon: Radio,
      path: "/admin-portal/note-seller-chatter",
      badge: "NEW",
    },
  ];

  return (
    <Sidebar>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Admin Portal</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.path}>
                  <SidebarMenuButton
                    onClick={() => navigate(item.path)}
                    isActive={location.pathname === item.path}
                    className="w-full justify-start"
                  >
                    <item.icon className="mr-2 h-4 w-4" />
                    {item.title}
                    {item.badge && (
                      <Badge variant="secondary" className="ml-auto">
                        {item.badge}
                      </Badge>
                    )}
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        
        <div className="mt-auto p-4">
          <Button
            onClick={onSignOut}
            variant="ghost"
            className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Sign Out
          </Button>
        </div>
      </SidebarContent>
    </Sidebar>
  );
}
